import Images from './Images';
import Instructions from './Instructions';

const InstructionsTab: React.FC = () => {
  return (
    <div className='w-full flex flex-col ~gap-6/8'>
      <Images />
      <Instructions />
    </div>
  );
};

export default InstructionsTab;
